import { Button, Form, Input, InputNumber, Select, message } from 'antd'
import type { FormProps } from 'antd'
import React, { useCallback, useState } from 'react'

import { patchTeacher, postTeacher } from '~/services/teacher'
import { ITeacher } from '~/types/teacher'

import { ModalFormContainer } from './style'

const Index: React.FC<{
  data: Partial<ITeacher>
  refreshTable: () => void
}> = (props) => {
  const { data, refreshTable } = props

  const [loading, setLoading] = useState(false)
  const onFinish = useCallback<
    Required<FormProps<Partial<ITeacher>>>['onFinish']
  >((value) => {
    setLoading(true)
    if (!data.id) {
      postTeacher(value)
        .then(() => {
          message.success('操作成功')
          refreshTable()
        })
        .catch((err) => {
          message.error(err?.message || '操作失败，请稍后再试')
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      patchTeacher(data.id, value)
        .then(() => {
          message.success('操作成功')
          refreshTable()
        })
        .catch((err) => {
          message.error(err?.message || '操作失败，请稍后再试')
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [])

  return (
    <ModalFormContainer>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        autoComplete="off"
        initialValues={data}
        onFinish={onFinish}
      >
        <Form.Item
          label="教师姓名"
          name="name"
          rules={[{ required: true, message: '请输入教师姓名' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="邮箱" name="email">
          <Input />
        </Form.Item>
        <Form.Item label="手机号码" name="phone">
          <Input />
        </Form.Item>
        <Form.Item label="介绍" name="introduction">
          <Input.TextArea rows={6} />
        </Form.Item>
        <Form.Item label="资质" name="qualification">
          <Input.TextArea />
        </Form.Item>
        <Form.Item label="国籍" name="nationality">
          <Input.TextArea />
        </Form.Item>
        <Form.Item 
          label="每课薪资" 
          name="rate"
          rules={[{ required: true, message: '请输入每节课的薪资' }]}
        >
          <InputNumber min={0} style={{ width: '100%' }} placeholder="请输入每节课的薪资" />
        </Form.Item>
        <Form.Item 
          label="货币类型" 
          name="currency"
          rules={[{ required: true, message: '请选择货币类型' }]}
          initialValue="CNY"
        >
          <Select
            placeholder="请选择货币类型"
            options={[
              { value: 'CNY', label: '¥ CNY - 人民币' },
              { value: 'USD', label: '$ USD - 美元' },
              { value: 'EUR', label: '€ EUR - 欧元' },
              { value: 'GBP', label: '£ GBP - 英镑' },
              { value: 'JPY', label: '¥ JPY - 日元' },
              { value: 'KRW', label: '₩ KRW - 韩元' },
              { value: 'PHP', label: '₱ PHP - 菲律宾比索' },
              { value: 'THB', label: '฿ THB - 泰铢' },
            ]}
          />
        </Form.Item>
        <Form.Item 
          label="课时卡/节" 
          name="cardsPerLesson"
          rules={[{ required: true, message: '请输入每节课需要的课时卡数量' }]}
        >
          <InputNumber min={1} style={{ width: '100%' }} placeholder="请输入每节课需要的课时卡数量" />
        </Form.Item>
        <Form.Item label="头像" name="profileImgUrl">
          <Input />
        </Form.Item>
        <Form.Item label="介绍视频" name="introVideoUrl">
          <Input />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button loading={loading} type="primary" htmlType="submit">
            提交
          </Button>
        </Form.Item>
      </Form>
    </ModalFormContainer>
  )
}

export default Index
